import React from 'react';
import PropTypes from 'prop-types';
import MetaControl from 'Components/UI/Meta/MetaControl';

export default function Education({ handleUpdate, client }) {
  return (
    <>
      <MetaControl
        attrName="schoolType"
        onChange={value => handleUpdate(client.attr('schoolType', value))}
        resource={client}
      />
      <MetaControl
        attrName="grade"
        onChange={value => handleUpdate(client.attr('grade', value))}
        resource={client}
      />
    </>
  );
}

Education.propTypes = {
  handleUpdate: PropTypes.func.isRequired,
  client: PropTypes.object.isRequired,
};
